import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { OperationEnum } from '../shared/enums/operation-type.enum';

@Injectable({ providedIn: 'root' })
export class QuoteDependentService extends ApiService {
  constructor(http: HttpClient) {
    super(http, 'QuoteDependent');
  }

  /** Get quoteDependentID by quoteID and dependentID (used when summary API doesn't return it) */
  getQuoteDependentId(quoteID: string, dependentID: string): Observable<string | null> {
    return this.paginate({
      skip: 0,
      take: 100,
      filters: [
        { field: 'QuoteID', operation: OperationEnum.Equals, value: quoteID, condition: 'AND' },
        { field: 'DependentID', operation: OperationEnum.Equals, value: dependentID, condition: 'AND' },
      ],
      orderBy: {},
    }).pipe(
      map((res) => {
        const item = res?.list?.[0];
        return (item?.quoteDependentID ?? (item as any)?.quoteDependentId ?? item?.id) ?? null;
      }),
    );
  }
}
